import { BaseActionObject, StateNodeConfig } from "xstate4"
import {
  Context,
  ResolveStudentPlanConflictSchema,
  Transitions
} from "../../../types"

export const resolveStudentPlanConflictTransition: StateNodeConfig<
  Context,
  ResolveStudentPlanConflictSchema,
  Transitions,
  BaseActionObject
> = {
  initial: "idle",
  states: {
    resolve_conflict_transition: {
      invoke: {
        src: "resolveStudyPlanConflict",
        onDone: {
          target: "#StudyPlan.teacher_view.idle",
          actions: "saveNewPlan"
        },
        onError: {
          // TODO: handle error state
        }
      }
    },
    idle: {
      on: {
        SAVE: {
          target: "resolve_conflict_transition"
        },
        CANCEL: {},
        "plan.checked": {
          // actions: assign((_ctx, { classId, studentId }) => ({ classId: classId, studentId: studentId }))
        }
      }
    }
  }
}
